import { render, staticRenderFns } from "./first.vue.vue?vue&type=template&id=08a69194&scoped=true"
import script from "./first.vue.vue?vue&type=script&lang=js"
export * from "./first.vue.vue?vue&type=script&lang=js"
import style0 from "./first.vue.vue?vue&type=style&index=0&id=08a69194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a69194",
  null
  
)

export default component.exports